<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates an auto complete box
    *
    * @since 20240104
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2024 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="autocomplete">
        <input v-if="!readOnly" :id="name" :name="name" v-model="valueActual" @input="typedLetter()" type="text" class="form-control"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter.prevent="onEnter"
            @focus="focus"
            @blur="unfocus"
        />
        <i v-if="selectedItem !== null" class="small">Last Selected: {{selectedItem.name}}</i><i v-if="selectedItem !== null" class="small pointer" role='button' @click="reset"> - click here to reset</i>
        <ul v-if="loading && !hideResults" class="autocomplete-results">
            <li class="autocomplete-result" value="">Loading Results...</li>
        </ul>
        <ul v-if="!loading && !readOnly && arrayActual.length > 0 && !hideResults" class="autocomplete-results">
            <li v-for="(item, ind) in arrayActual" :key="ind" @click="setResult(item)" @mouseover="hoverItem(ind)" @mouseout="unhoverItem(ind)" :class="ind == index ? 'selected' : ''" value="item">{{item.name}}</li>
        </ul>
        <span v-if="readOnly">{{valueActual}}</span>
    </div>
</template>

<script>
    export default{
        props: {
            //the name of the editor
            name: {
                type: String,
                default: 'autocomplete'
            },
            //the value of the editor
            value: {
                type: String,
                default: ''
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            searchArray: {
                type: Array
            },
            searchLogic: {
                type: String,
                default: ''
            },
            searchMethod: {
                type: String,
                default: ''
            },
            extraParams: {
                type: Object
            }
        },
        data() {
            return {
                valueActual: this.value,
                selectedItem: null,
                arrayToUse: [],
                index: -1,
                hideResults: false,
                loading: false,
                hovering: false,
                typedLetters: 0
            };
        },
        computed: {
            /**
             * gets the style of the outer div to set the width of the element
             * @returns object the style
             */
            arrayActual: function(){
                if(this.valueActual.length > 0){
                    return this.arrayToUse;
                } else {
                    return [];
                }
            },
        },
        methods: {
            setResult: function(result) {
                this.valueActual = result.value;
                this.index = -1;
                this.hideResults = true;
                this.selectedItem = result;
                this.$emit('input', this.valueActual);
                this.$emit('selected', this.selectedItem);
            },
            reset: function(result) {
                this.valueActual = '';
                this.index = -1;
                this.hideResults = true;
                this.selectedItem = null;
                this.$emit('input', this.valueActual);
                this.$emit('selected', 'reset');
            },
            onArrowDown: function(){
                this.index++;
                if(this.index >= this.arrayActual.length){
                    this.index = 0;
                }
            },
            onArrowUp: function(){
                this.index--;
                if(this.index < 0){
                    this.index = this.arrayActual.length-1;
                }
            },
            onEnter: function(){
                if(this.index >= 0 && this.index < this.arrayActual.length){
                    this.setResult(this.arrayActual[this.index]);
                    this.index = -1;
                }
            },
            typedLetter: function(){
                this.typedLetters++;
                var currLetters = this.typedLetters;
                var self = this;
                setTimeout(function(){
                    if(self.typedLetters == currLetters){
                        self.typed();
                    }
                }, 500)
                this.$emit('input', this.valueActual)
            },
            typed: function(){
                this.typedLettters = 0;
                this.hideResults = false;
                if(this.searchLogic.length > 0 && this.searchMethod.length > 0){
                    this.getJob();
                }
            },
            hoverItem: function(item){
                this.index=item;
                this.hovering = true;
            },
            unhoverItem: function(item){
                this.index=item;
                this.hovering = false;
            },
            focus: function(){
                this.hideResults=false;
                this.hovering = false;
            },
            unfocus: function(){
                if(!this.hovering){
                    this.hideResults=true;
                }
            },
            getJob: function () {
                this.loading = true;
                var save_params = {
                    search: this.valueActual
                };
                if(this.extraParams !== undefined && this.extraParams !== null){
                    for (var key in this.extraParams) {
                        if (this.extraParams.hasOwnProperty(key)) {
                            save_params[key] = this.extraParams[key];
                        }
                    }
                }
                console.log(save_params);
                this.$reportJobs.push({
                    autoCompleteJob: true,
                    logic: this.searchLogic,
                    method: this.searchMethod,
                    object: this,
                    params: save_params
                });
            },
            setJobProgress: function(data){
                
            },
            setJobComplete: function(data){
                this.loading = false;
                this.arrayToUse = data.graphData;
            },
            setJobError: function(data){
                this.loading = false;
                console.log('An error occurred with the autocomplete');
                if(data.error !== undefined){
                    console.log(data.error);
                }
                this.arrayToUse = [];
            },
        }
    }
</script>